import { render } from "./SystemError.vue?vue&type=template&id=5a81c24f"
const script = {}

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__